// extracted by mini-css-extract-plugin
export var colorSquare = "_ua-0";
export var danger = "_ua-5";
export var lightPink = "_ua-8";
export var neutralBlue = "_ua-7";
export var neutralYellow = "_ua-6";
export var normal = "_ua-1";
export var primary = "_ua-2";
export var primaryLight = "_ua-3";
export var solidBlack = "_ua-g";
export var solidGreen = "_ua-b";
export var solidLightBlue = "_ua-d";
export var solidNavy = "_ua-c";
export var solidOrange = "_ua-f";
export var solidPink = "_ua-e";
export var solidRed = "_ua-9";
export var solidYellow = "_ua-a";
export var success = "_ua-4";